export const version = import.meta.env.VITE_APP_VERSION;
export default version;
